const styles = {
  blue: {
    color: "rgb(33,77,142)",
    paddingRight: "0",
  },
  red: {
    color: "rgb(220,38,72)",
    paddingLeft: "0",
  },
  leftArrow: {
    height: "3vh",
    width: "3vw",
  },
  black: {
    color: "rgb(45,45,45)",
  },
  container: {

    marginLeft: "30px",
    marginRight: "30px",
    paddingLeft: "0",
    paddingRight: "0",
    paddingBottom: "80px",
  },
  primaryText: {
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "18px",
    color: "#818C99",
    letterSpacing: "0.2px",
  },
  secondHeader: {
    fontFamily: "Roboto",
    fontWeight: "400",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    fontSize: "14px",
    marginTop: "4vh",
    // marginLeft: "8%"
  },
  cancelButton: {
    background: "#fff",
    border: "1px solid #06844D",
    width: "87vw",
    marginLeft: "6.5vw",
    height: "44px",
    position: "fixed",
    bottom: "23px",
    left: 0,
    zIndex: 2,
  },
  statusLine: {
    //marginLeft: "30vw",
  },
  spinner: {
    marginTop: "30vh",
  },
  cancelSpinner: {
    width: "100vw",
    height: "100vh",
    position: "absolute",
    top: "0",
    left: "0",
    padding: "0",
  },
  green: {
    color: "#06844D",
  },
  firstUpperCase: {
    textTransform: "capitalize",
  },
  headerText: {
    position: "relative",
    paddingLeft: "23px",
    fontFamily: "IBM Plex Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "23px",
    lineHeight: "28px",
    color: "#000000",
    textAlign: "left",
  },
};

export default styles;
